import { render, staticRenderFns } from "./ReportActionBlock.vue?vue&type=template&id=0e6a9150&"
import script from "./ReportActionBlock.vue?vue&type=script&lang=js&"
export * from "./ReportActionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports